import {Injectable} from '@angular/core';
import {BaseDaoService} from '@q9elements/ui-kit/common';
import {CookieService} from 'ngx-cookie-service';

@Injectable()
export class RequirementAttachmentsService extends BaseDaoService {
  private REQUIREMENT_KEY = 'ELEMENTS.COPIED.REQUIREMENT';

  constructor(private cookieService: CookieService) {
    super();
  }

  cleanupRequirementLink(userId: string) {
    const cacheJson = this.cookieService.get(this.REQUIREMENT_KEY);
    if (!cacheJson) {
      return;
    }

    const cache = JSON.parse(cacheJson);
    if (userId && cache.user && userId.toString() !== cache.user.toString()) {
      this.cookieService.delete(this.REQUIREMENT_KEY);
    }
  }
}
